module.exports = __webpack_public_path__ + "images/mdekoning7287df8a5f586a0d029d4886d79a0953.png";